export default "<bart-user-info>\r\n</bart-user-info>\r\n<p>reintialize-main works!</p>"